export const sl = {
  // Header Navigation
  nav: {
    home: "DOMOV",
    company: "XIAMEN TOWER TECH",
    sourcing: "UVOZ",
    otherServices: "DRUGE STORITVE",
    projects: "PROJEKTI",
    blog: "BLOG",
    partners: "Partnerji",
    contact: "KONTAKT"
  },
  
  // Hero Section
  hero: {
    title: "Uvoz brez tveganja",
    titleHighlight: "brez tveganja",
    subtitle: "iz Kitajske",
    description1: "Od tovarne do vašega skladišča",
    description1Highlight: "– brez neprijetnih presenečenj.",
    description2: "Nadzorujemo vsak korak, da lahko vaše podjetje",
    description2Highlight: "raste brez skrbi.",
    startSourcing: "Začnite zdaj",
    learnMore: "Več informacij"
  },

  // About Section
  about: {
    title: "O podjetju Xiamen Tower Technology Co., Ltd.",
    description: "Ustanovljeno leta 2019, podjetje Xiamen Tower Technology Co., Ltd. je vodilno podjetje za uvoz-izvoz in upravljanje dobavne verige s sedežem v provinci Fujian, Kitajska. Specializirani smo za povezovanje mednarodnih podjetij z zanesljivimi kitajskimi proizvajalci ter zagotavljanje kakovosti, učinkovitosti in preglednosti pri vsakem koraku.",
    feature1Title: "Večjezična Ekipa",
    feature1Description: "Govorimo angleško, nemško, špansko, slovensko in srbsko ter zagotavljamo jasno komunikacijo skozi celoten proces.",
    feature2Title: "Globalna Podpora pri Dostavi",
    feature2Description: "Strankam po vsem svetu nudimo nemoteno pošiljanje, logistiko in celostne rešitve dostave.",
    feature3Title: "Preverjeno Omrežje Proizvajalcev",
    feature3Description: "Sodelujemo izključno s preverjenimi in zanesljivimi proizvajalci za dosledno kakovost."
  },

  // Services Section
  services: {
    title: "Naše storitve",
    description: "Zagotavljamo celovite rešitve za vaše potrebe po uvozu in proizvodnji na Kitajskem.",
    subtitle: "Podpiramo vas v eni ali več fazah procesa.",
    mainTitle: "Storitve uvoza",
    sourcingTitle: "Uvoz",
    otherServicesTitle: "Dodatne storitve uvoza",
    sourcingDescription1: "Prevzamemo celoten proces uvoza: od izbire idealnega dobavitelja in razvoja produkta do strogih kontrol kakovosti in optimizirane logistike.",
    sourcingDescription2: "Nismo le posrednik – smo vaš strateški partner pri globalnem uvozu, ki zagotavlja učinkovitost, prihranke in varnost pri vsakem projektu.",
    otherServicesDescription1: "Ponujamo vrsto dopolnilnih storitev, ki vam omogočajo uspešno izvedbo mednarodnih projektov.",
    otherServicesDescription2: "Od strateškega svetovanja do vstopa na nove trge – naša ekipa vas spremlja kot zanesljiv partner za globalno rast.",
    hideDetails: "Skrij Podrobnosti",
    showInfo: "+ VEČ INFO",
    moreInfo: "Več informacij",
    process: "Naš proces",
    benefits: "Ključne prednosti",
    supplierSelection: {
      title: "Izbor Dobaviteljev",
      description: "Identificiramo in preverimo zanesljive proizvajalce na Kitajskem, ki izpolnjujejo vaše zahteve in standarde kakovosti.",
      steps: {
        step1: "Analiza zahtev in raziskava trga",
        step2: "Identifikacija in predizbor kvalificiranih dobaviteljev",
        step3: "Obiski tovarn in tehnične ocene",
        step4: "Preverjanje in certifikacija dobaviteljev"
      },
      benefits: {
        benefit1: "Dostop do preverjenih premium proizvajalcev",
        benefit2: "Zmanjšano tveganje s strogim preverjanjem",
        benefit3: "Skrajšan čas kvalifikacije dobaviteljev"
      }
    },
    productDevelopment: {
      title: "Razvoj Produktov",
      description: "Vašo idejo spremenimo v kakovosten izdelek – od zasnove do serijske proizvodnje – z najvišjimi standardi in garancijami.",
      steps: {
        step1: "Tehnične specifikacije in zahteve oblikovanja",
        step2: "Izdelava prototipov in vzorcev",
        step3: "Tehnična optimizacija in analiza stroškov",
        step4: "Priprava proizvodnje in razvoj orodij"
      },
      benefits: {
        benefit1: "Oblikovanje z osredotočenostjo na proizvodnjo",
        benefit2: "Hitrejši vstop na trg",
        benefit3: "Nenehne izboljšave glede na povratne informacije trga"
      }
    },
    qualityControl: {
      title: "Kontrola Kakovosti",
      description: "Nadzorujemo vsako fazo proizvodnje, da zagotovimo skladnost in odličnost v vseh serijah izdelkov.",
      steps: {
        step1: "Pregled materialov in preverjanje pred proizvodnjo",
        step2: "Nadzor med proizvodnjo (DUPRO)",
        step3: "Končni pregledi pred pošiljanjem (PSI)",
        step4: "Podrobna poročila s foto dokumentacijo"
      },
      benefits: {
        benefit1: "Zgodnje odkrivanje napak v kakovosti",
        benefit2: "Manj vračil in reklamacij",
        benefit3: "Dosledna raven kakovosti v vseh serijah"
      }
    },
    logisticsManagement: {
      title: "Upravljanje Logistike",
      description: "Koordiniramo celotno dobavno verigo za učinkovit in zanesljiv uvoz iz Kitajske do vašega skladišča.",
      steps: {
        step1: "Izbor in pogajanja z logističnimi partnerji",
        step2: "Carinjenje in izvozna dokumentacija",
        step3: "Konsolidacija pošiljk in optimizacija transporta",
        step4: "Sledenje v realnem času do končne dostave"
      },
      benefits: {
        benefit1: "Optimizirani stroški pošiljanja z inteligentnim usmerjanjem",
        benefit2: "Hitrejše dostave z ekspresnimi možnostmi",
        benefit3: "Popolno zavarovanje pošiljk in zaščita tovora"
      }
    }
  },

  // Service Process & Additional Services
  serviceProcess: {
    title: "Naš proces uvoza:",
    steps: [
      "Raziskava trga in identifikacija dobaviteljev",
      "Pogajanja o cenah in pogodbenih pogojih",
      "Zagotavljanje kakovosti in upravljanje rokov",
      "Koordinacija logistike od začetka do konca"
    ]
  },

  additionalServices: {
    title: "Dodatne storitve:",
    items: [
      "Svetovanje za vstop na trg",
      "Podpora pri prilagajanju produktov",
      "Pomoč pri regulativni skladnosti",
      "Razvoj dolgoročnih partnerstev"
    ]
  },

  // Service Details (for expanded info sections)
  serviceDetails: {
    supplierSelection: {
      fullDescription: "Naš celovit proces izbire dobaviteljev vključuje temeljito preverjanje ozadja, revizije tovarn, pregled certifikatov kakovosti in oceno proizvodnih zmogljivosti. Preverjamo poslovna dovoljenja, izvozne kvalifikacije in reference strank, da zagotovimo sodelovanje z zanesljivimi proizvajalci.",
      benefits: [
        "Preverjanje in revizije tovarn",
        "Preverjanje certifikatov kakovosti", 
        "Ocena proizvodnih zmogljivosti",
        "Ocena finančne stabilnosti",
        "Potrjevanje prejšnjih referenc strank"
      ]
    },
    productDevelopment: {
      fullDescription: "Od koncepta do proizvodnje vodimo vas skozi celoten proces razvoja izdelka. Naša ekipa sodeluje s proizvajalci pri ustvarjanju prototipov, izboljšavi zasnove, izvajanju testiranj in zagotavljanju, da vaš izdelek izpolnjuje mednarodne standarde pred začetkom množične proizvodnje.",
      benefits: [
        "Razvoj prototipov",
        "Optimizacija dizajna",
        "Testiranje in potrjevanje kakovosti", 
        "Skladnost z mednarodnimi standardi",
        "Načrtovanje časovnic proizvodnje"
      ]
    },
    qualityControl: {
      fullDescription: "Naša ekipa za kontrolo kakovosti izvaja predhodne inšpekcije proizvodnje, spremljanje med procesom in končne inšpekcije izdelkov. Uporabljamo mednarodne standarde kakovosti in pripravljamo podrobna poročila s fotografijami, da zagotovimo, da vaši izdelki izpolnjujejo vse specifikacije.",
      benefits: [
        "Predinspekce proizvodnje",
        "Spremljanje kakovosti med procesom",
        "Končna inšpekcija produkta",
        "Podrobna poročila o kakovosti", 
        "Skladnost z mednarodnimi standardi"
      ]
    },
    logisticsManagement: {
      fullDescription: "Koordiniramo celoten logistični proces – od prevzema v tovarni do dostave v vaše skladišče. To vključuje pripravo izvozne dokumentacije, carinjenje, organizacijo transporta, zavarovanje in sledenje pošiljk v realnem času med celotnim prevozom.",
      benefits: [
        "Obravnava izvozne dokumentacije",
        "Pomoč pri carinjenju",
        "Koordinacija transporta in tovora",
        "Zavarovalna kritja",
        "Sledenje pošiljke v realnem času"
      ]
    }
  },

  // Global Reach Section
  globalReach: {
    title: "Globalni Doseg",
    description: "Z našim močnim omrežjem dobaviteljev in lokalnim znanjem na Kitajskem podpiramo stranke po vsem svetu z zanesljivim pridobivanjem, nadzorom kakovosti in celovitim vodenjem projektov v različnih industrijah.",
    feature1Title: "🌍 Države, ki jih Strežemo",
    feature1Description: "Podpora strankam v vseh večjih svetovnih regijah.",
    feature2Title: "🤝 Mednarodne Stranke",
    feature2Description: "Zaupajo nam podjetja iz Evrope, Amerik, Azije in širše.",
    feature3Title: "🏭 Preverjeno Omrežje Dobaviteljev",
    feature3Description: "Sodelujemo samo z auditiranimi in zaupanja vrednimi proizvajalci.",
    feature4Title: "📦 Celovito Vodenje Projektov",
    feature4Description: "Od izbire dobaviteljev do končne dostave koordiniramo vsak korak."
  },
 

  // Projects Section
  projects: {
    title: "Kategorije izdelkov",
    description: "Raziščite naš raznolik spekter kategorij produktov in odkrijte kakovostne rešitve, ki jih lahko nabavimo za vaše poslovne potrebe.",
    subtitle: "S čim delamo",
    viewDetails: "Poglejte Podrobnosti",
    viewProducts: "Poglejte Produkte",
    hideProducts: "Skrij",
    contactForDetails: "Za podrobne informacije o produktih in cene se obrnite na našo ekipo preko spodnjega obrazca.",
    lookingForSpecific: "Iščete nekaj posebnega?",
    lookingDescription: "Naši strokovnjaki za nabavo vam lahko pomagajo najti prave proizvajalce in dobavitelje na Kitajskem za katero koli kategorijo produktov ali prilagojene zahteve.",
    contactTeam: "Kontaktirajte Našo Ekipo",
    viewAllCategories: "Poglejte Vse Kategorije",
    allProjects: "Vsi Projekti",
    startYourProject: "Začnite Vaš Projekt",
    categories: {
      electronics: "ELEKTRONIKA",
      machinery: "STROJI", 
      tools: "ORODJA",
      packaging: "EMBALAŽA",
      consumer: "POTROŠNIŠKO BLAGO",
      textiles: "TEKSTIL",
      apparel: "OBLAČILA IN IZDELKI ZA DOJENČKE"
    }
  },

  // Products (translated from mockData)
  products: {
    electronics: {
      solarPanels: {
        name: "Sistemi sončnih panelov",
        description: "Monokristalni in polikristalni paneli visoke učinkovitosti"
      },
      electricBikes: {
        name: "Električna kolesa in skuterji", 
        description: "Zložljiva e-kolesa in pametni skuterji z GPS-om in dolgim trajanjem baterije"
      },
      ledLights: {
        name: "LED sončne ulične svetilke",
        description: "Vse-v-enem sistemi s senzorji gibanja in daljinskim upravljanjem"
      },
      powerBanks: {
        name: "Prenosne sončne baterije",
        description: "Visokokapacitetni polnilniki za zunanjo ali nujno uporabo"
      },
      smartHome: {
        name: "Pametne naprave za dom",
        description: "WiFi termostati, pametne vtičnice in glasovno upravljanje"
      }
    },
    machinery: {
      cncMachining: {
        name: "CNC obdelovalni centri",
        description: "3–5-osni natančni stroji za proizvodnjo in prototipiranje"
      },
      conveyor: {
        name: "Industrijski transportni sistemi", 
        description: "Avtomatizirani trakovi za pakiranje in ravnanje z materiali"
      },
      hydraulicPress: {
        name: "Hidravlične stiskalnice",
        description: "Stroji za oblikovanje kovin in industrijske uporabe"
      },
      pneumaticTools: {
        name: "Pnevmatsko orodje in komponente",
        description: "Kompresorji, valji in priključki"
      },
      weldingEquipment: {
        name: "Varilna oprema",
        description: "MIG/TIG varilci, plazemski rezalniki in dodatna oprema"
      }
    },
    tools: {
      measuring: {
        name: "Natančni merilni instrumenti",
        description: "Digitalna merila, mikrometri in indikatorji"
      },
      toolSets: {
        name: "Industrijski seti orodij",
        description: "Mehanični in električni kompleti za profesionalno uporabo"
      },
      powerAccessories: {
        name: "Dodatki za električna orodja", 
        description: "Svedri, žagine liste in brusni diski"
      },
      handTools: {
        name: "Ročno orodje",
        description: "Ključi, izvijači, klešče in imbus ključi"
      },
      safetyEquipment: {
        name: "Zaščitna oprema",
        description: "Očala, rokavice, čelade in zaščita za sluh"
      }
    },
    packaging: {
      packagingMachines: {
        name: "Avtomatski stroji za pakiranje",
        description: "Stroji za pakiranje hrane, farmacevtskih in potrošnih izdelkov"
      },
      labelingSystems: {
        name: "Sistemi za etiketiranje in tiskanje",
        description: "Industrijski tiskalniki in stroji za kodiranje"
      },
      sealingEquipment: {
        name: "Oprema za zapiranje", 
        description: "Toplotni in vakuumski zapiralci ter avtomatski dispenzerji trakov"
      },
      corrugatedBoxes: {
        name: "Valovite škatle in kartoni",
        description: "Tiskane transportne škatle različnih velikosti"
      },
      protectivePackaging: {
        name: "Zaščitna embalaža",
        description: "Pena, mehurčkasti ovoj in zaščitni materiali za pakiranje"
      }
    },
    consumer: {
      smartAppliances: {
        name: "Pametne gospodinjske naprave",
        description: "Robotski sesalniki, čistilci zraka in pametni termostati"
      },
      furniture: {
        name: "Pohištvo za sestavljanje",
        description: "Stolice, mize in sistemi za shranjevanje"
      },
      kitchenGadgets: {
        name: "Kuhinjski pripomočki", 
        description: "Cvrtniki na vroč zrak, grelniki vode in inovativna orodja"
      },
      fitnessAccessories: {
        name: "Fitnes dodatki",
        description: "Blazine za jogo, elastični trakovi, steklenice in vadbena oprema"
      },
      phoneAccessories: {
        name: "Dodatki za telefon",
        description: "Ovitek, brezžični polnilci, slušalke in nosilci"
      }
    },
    textiles: {
      technicalFabrics: {
        name: "Tehnične tkanine",
        description: "Ognjevarne, vodoodbojne in antibakterijske tkanine za posebne namene"
      },
      sustainableClothing: {
        name: "Trajnostna oblačila",
        description: "Organski bombaž, bambusova vlakna in recikliran poliester"
      },
      homeTextiles: {
        name: "Hišni tekstil",
        description: "Posteljnina, zavese, prti in dekorativne tkanine"
      },
      workwear: {
        name: "Delovna oblačila in uniforme", 
        description: "Poklicna oblačila, varnostni jopiči, predpasniki in korporativne uniforme"
      },
      cottonProducts: {
        name: "Bombažni izdelki",
        description: "Majice, brisače, nogavice in vsakdanja oblačila"
      }
    },
    apparel: {
      babyProducts: {
        name: "Izdelki in dodatki za dojenčke",
        description: "Oblačila, plenice, stekleničke, vozički, avtosedeži in varnostni dodatki"
      },
      kidsClothing: {
        name: "Otroška oblačila in obutev",
        description: "Šolske uniforme, športni copati in sezonske kolekcije"
      },
      adultsFashion: {
        name: "Moda za odrasle",
        description: "Vsakdanja, poslovna in športna oblačila ter modni dodatki"
      },
      maternitywear: {
        name: "Nosečniška in doječa oblačila", 
        description: "Udobna oblačila za nosečnost, dojenje in obdobje po porodu"
      },
      seasonalCollections: {
        name: "Sezonske kolekcije",
        description: "Zimska, poletna in praznična oblačila za vse starosti"
      },
      footwearAccessories: {
        name: "Obutev in dodatki",
        description: "Čevlji, škornji, torbice, pasovi in modni nakit"
      }
    }
  },

  // Blog Section
  blog: {
    title: "Najnovejše EXPO novice in panožni vpogledi s Kitajske",
    description: "Ostanite na tekočem z najnovejšimi trendi, novicami in vpogledi iz kitajske proizvodne in izvozne industrije.",
    chinaExpoNews: "Najnovejše Kitajske EXPO Novice",
    industryInsights: "Panožni Vpogledi",
    industryInsightsDescription: "Tržni trendi, strategije nabave in analize, ki oblikujejo globalno proizvodnjo.",
    dailyArticles: "Dnevne Novice",
    dailyArticlesSubtext: "Sveže novice in vpogledi iz sveta trgovine – vsak dan",
    readMore: "Preberi Več",
    viewAllArticles: "Vsi Članki",
    lastUpdated: "Nazadnje Posodobljeno",
    refreshAll: "Osveži Vse",
    updating: "Posodabljam...",
    autoUpdatesMonthly: "Samodejne mesečne posodobitve",
    liveFeeds: "Živi panožni viri",
    expoUpdates: "Kitajske EXPO Posodobitve",
    expoDescription: "Najnovejše novice iz CIIE, Canton Fair in pomembnih trgovinskih dogodkov"
  },

  // Contact Section
  contact: {
    title: "Kontaktirajte Nas",
    description: "Pripravljeni začeti vašo nabavno pot? Stopite v stik z našo ekipo za prilagojene rešitve.",
    alternateTitle: "Ostanimo v stiku!",
    alternateDescription: "Če imate kakršna koli vprašanja ali poizvedbe o naših storitvah, nam pošljite kontaktni obrazec ali se obrnite neposredno na naš urad.",
    fullName: "Polno Ime",
    email: "E-poštni Naslov",
    company: "Podjetje",
    subject: "Zadeva",
    message: "Sporočilo",
    yourName: "Vaše Ime",
    yourEmail: "Vaš E-naslov",
    companyName: "Ime Podjetja",
    tellUs: "Povejte nam o zahtevah vašega projekta...",
    attachFiles: "Priloži datoteke",
    filesSelected: "datoteka(e) izbrano",
    acceptPrivacy: "Sprejemam pravilnik o zasebnosti",
    sendMessage: "Pošlji Sporočilo",
    messageSent: "Sporočilo uspešno poslano!",
    responseTime: "Odgovorili vam bomo v 24 urah.",
    validationError: "Napaka pri preverjanju",
    fillRequiredFields: "Prosimo, izpolnite vsa obvezna polja.",
    invalidEmail: "Prosimo, vnesite veljaven e-poštni naslov.",
    errorTitle: "Napaka",
    errorMessage: "Sporočila ni bilo mogoče poslati. Poskusite znova ali nas kontaktirajte neposredno na office@towertech-xm.com",
    phoneLabel: "Telefon",
    emailLabel: "E-pošta",
    locationLabel: "Lokacija",
    foundedLabel: "Ustanovljeno",
    ourOffice: "Naš Urad",
    howHelp: "Kako vam lahko pomagamo?",
    requirementsDetail: "Prosimo, razložite vaše zahteve čim bolj podrobno. Pošljete nam lahko tudi vso relevantno dokumentacijo (načrti, podrobnosti), če želite. Vse poizvedbe bo naša ekipa promptno obdelala in odgovorila.",
    attachDocumentation: "Ali potrebujete priložiti dokumentacijo vašega projekta?",
    privacyAccept: "Prebral/-a sem in sprejemam",
    privacyPolicies: "Pravilnik o zasebnosti",
    contactForm: "Pošljite nam sporočilo preko našega kontaktnega obrazca"
  },

  // Footer
  footer: {
    description: "Vaš zaupanja vreden partner za uvoz brez tveganja iz Kitajske. Povezujemo podjetja po svetu z zanesljivimi proizvajalci in zagotavljamo kakovost pri vsakem koraku.",
    quickLinks: "Hitre Povezave",
    home: "Domov",
    about: "O Nas", 
    services: "Storitve",
    projects: "Projekti",
    blog: "Blog",
    contact: "Kontakt",
    legal: "Pravno",
    termsOfService: "Pogoji Storitev",
    privacyPolicy: "Pravilnik o Zasebnosti",
    cookiePolicy: "Pravilnik o Piškotkih",
    gdprCompliance: "GDPR Skladnost",
    languagesWeSpeak: "Jeziki, ki jih govorimo",
    rights: "Vse pravice pridržane.",
    adminPanel: "Upravljalni Panel",
    scrollToTop: "Pojdi na vrh"
  },

  // Legal Pages
  legal: {
    goBack: "Nazaj",
    lastUpdated: "Zadnja posodobitev: December 2024",
    
    // Terms of Service
    terms: {
      title: "Pogoji storitve",
      section1: {
        title: "1. Strinjanje s pogoji",
        content: "Z dostopom do spletne strani Xiamen Tower Technology Co., Ltd. (towertech-xm.com) in njeno uporabo se strinjate, da vas zavezujejo ti Pogoji storitve in vsi veljavni zakoni ter predpisi. Če se ne strinjate s katerim koli od teh pogojev, vam je uporaba te strani prepovedana."
      },
      section2: {
        title: "2. Informacije o podjetju",
        company: "Podjetje: Xiamen Tower Technology Co., Ltd.",
        address: "Naslov: Provinca Fujian, Kitajska",
        phone: "Telefon: +86 15381939338",
        email: "E-pošta: office@towertech-xm.com",
        founded: "Ustanovljeno: 2019",
        services: "Xiamen Tower Technology Co., Ltd. zagotavlja storitve uvoza-izvoza in oskrbe s proizvodi, specializirana za povezovanje mednarodnih podjetij s kitajskimi proizvajalci. Naše storitve vključujejo:"
      },
      section3: {
        title: "3. Licenca za uporabo",
        content: "Odobren je začasni prenos ene kopije materialov na spletni strani Xiamen Tower Technology za osebno, nekomercialno začasno ogledovanje. To je odobritev licence, ne prenos lastništva."
      },
      section4: {
        title: "4. Izključitev odgovornosti",
        content: "Materiali na spletni strani Xiamen Tower Technology so na voljo 'kakršni so'. Xiamen Tower Technology ne daje nobenih jamstev, izrecnih ali nakazanih, in s tem zavrača in izničuje vsa druga jamstva."
      },
      section5: {
        title: "5. Omejitve",
        content: "Xiamen Tower Technology ali njeni dobavitelji v nobenem primeru ne bodo odgovorni za morebitno škodo (vključno, vendar ne omejeno na škodo zaradi izgube podatkov ali dobička ali zaradi prekinitve poslovanja), ki izhaja iz uporabe ali nezmožnosti uporabe materialov na spletni strani Xiamen Tower Technology."
      },
      section6: {
        title: "6. Kontaktne informacije",
        content: "Za vsa vprašanja o teh Pogojih storitve nas kontaktirajte na office@towertech-xm.com ali +86 15381939338."
      }
    },
    
    // Privacy Policy
    privacy: {
      title: "Pravilnik o zasebnosti",
      section1: {
        title: "1. Informacije, ki jih zbiramo",
        intro: "Xiamen Tower Technology zbira informacije, ki nam jih posredujete neposredno, na primer ko:",
        items: [
          "Izpolnite naše kontaktne obrazce",
          "Zaprosite za ponudbe ali informacije o naših storitvah",
          "Se naročite na naš newsletter",
          "Komunicirate z nami po e-pošti ali telefonu",
          "Obiščete našo spletno stran (preko piškotkov in podobnih tehnologij)"
        ]
      },
      section2: {
        title: "2. Kako uporabljamo vaše informacije",
        content: "Informacije, ki jih zbiramo, uporabljamo za zagotavljanje, vzdrževanje in izboljševanje naših storitev, odgovarjanje na vaše poizvedbe, pošiljanje marketinških sporočil (z vašim soglasjem) in izpolnjevanje pravnih obveznosti."
      },
      section3: {
        title: "3. Deljenje informacij",
        content: "Ne prodajamo, trgujemo ali kako drugače prenašamo vaših osebnih podatkov tretjim stranem brez vašega soglasja, razen kot je opisano v tem pravilniku ali kot zahteva zakon."
      },
      section4: {
        title: "4. Varnost podatkov",
        content: "Izvajamo ustrezne varnostne ukrepe za zaščito vaših osebnih podatkov pred nepooblaščenim dostopom, spreminjanjem, razkritjem ali uničenjem."
      },
      section5: {
        title: "5. Vaše pravice",
        content: "Imate pravico dostopati, posodobiti ali izbrisati svoje osebne podatke. Prav tako se lahko kadarkoli odjavite od prejemanja marketinških sporočil."
      },
      section6: {
        title: "6. Kontaktirajte nas",
        content: "Če imate vprašanja o tem Pravilniku o zasebnosti, nas kontaktirajte na office@towertech-xm.com."
      }
    },
    
    // Cookie Policy
    cookies: {
      title: "Pravilnik o piškotkih",
      section1: {
        title: "1. Kaj so piškotki",
        content: "Piškotki so majhne besedilne datoteke, ki se shranijo na vaši napravi, ko obiščete našo spletno stran. Pomagajo nam zagotoviti boljšo uporabniško izkušnjo."
      },
      section2: {
        title: "2. Vrste piškotkov, ki jih uporabljamo",
        essential: "Bistveni piškotki: Potrebni za pravilno delovanje spletne strani",
        analytics: "Analitični piškotki: Pomagajo nam razumeti, kako obiskovalci uporabljajo našo spletno stran",
        preferences: "Piškotki nastavitev: Zapomnijo si vaše nastavitve in preference"
      },
      section3: {
        title: "3. Upravljanje piškotkov",
        content: "Piškotke lahko nadzirate in upravljate preko nastavitev brskalnika. Upoštevajte, da lahko onemogočanje določenih piškotkov vpliva na funkcionalnost spletne strani."
      }
    },
    
    // GDPR Compliance
    gdpr: {
      title: "GDPR skladnost",
      section1: {
        title: "1. Varstvo podatkov",
        content: "Xiamen Tower Technology se zavezuje k varstvu vaših osebnih podatkov v skladu z Generale uredbo o varstvu podatkov (GDPR)."
      },
      section2: {
        title: "2. Vaše pravice pod GDPR",
        rights: [
          "Pravica do dostopa do vaših osebnih podatkov",
          "Pravica do popravka netočnih podatkov",
          "Pravica do izbriša vaših podatkov",
          "Pravica do omejitve obdelave",
          "Pravica do prenosljivosti podatkov",
          "Pravica do ugovora obdelavi"
        ]
      },
      section3: {
        title: "3. Kontaktirajte našega pooblaščenca za varstvo podatkov",
        content: "Za vsa vprašanja povezana z GDPR kontaktirajte našega pooblaščenca za varstvo podatkov na office@towertech-xm.com."
      }
    }
  },

  // FAQ Section
  faq: {
    title: "Pogosto zastavljena vprašanja",
    subtitle: "Vse, kar morate vedeti o uspešnem uvozu",
    takeAdvantage: "Izkoristite prednosti varnega globalnega uvoza.",
    helpOptimize: "Pomagamo vam optimizirati stroške in zmanjšati tveganja pri vaših projektih.",
    successfulImporting: "Uspešen uvoz se začne s strokovnjaki in zanesljivimi procesi.",
    startProject: "Začnite svoj projekt",
    questions: [
      {
        question: "V katerih regijah ponujate storitve uvoza?",
        answer: "Delujemo na Kitajskem in podpiramo stranke po vsem svetu z nabavo, upravljanjem dobaviteljev, kontrolo kakovosti in mednarodno dostavo iz Kitajske."
      },
      {
        question: "Ponujate storitve razvoja izdelkov po meri?",
        answer: "Da, zagotavljamo popolno podporo – od koncepta do končnega izdelka – z nadzorom kakovosti v vsaki fazi."
      },
      {
        question: "Kako zagotavljate kakovost izdelkov?",
        answer: "Izvajamo sistematične tovarniške revizije in kontrolo kakovosti za vsak proizvodni cikel, z ekipo na terenu na Kitajskem."
      },
      {
        question: "Zagotavljate logistično podporo?",
        answer: "Da, koordiniramo celoten proces – od izvoza, carine in dokumentacije do dostave v vaše skladišče."
      }
    ]
  },

  // Languages
  languages: {
    en: "English",
    es: "Español",
    de: "Deutsch", 
    sl: "Slovenščina",
    sr: "Српски"
  },

  // Common UI Elements
  ui: {
    backButton: "Nazaj",
    loading: "Nalagam...",
    error: "Napaka",
    success: "Uspeh",
    close: "Zapri",
    save: "Shrani",
    cancel: "Prekliči",
    delete: "Izbriši",
    edit: "Uredi",
    view: "Poglej",
    viewDetails: "Poglej podrobnosti",
    hide: "Skrij",
    show: "Prikaži",
    more: "Več",
    less: "Manj",
    readMore: "Preberi več",
    learnMore: "Izvedi več",
    getStarted: "Začnite",
    keyBenefits: "Ključne koristi:"
  },

  // Cookie Consent Banner
  cookies: {
    bannerTitle: "Uporabljamo piškotke",
    bannerDescription: "Uporabljamo piškotke za izboljšanje vaše izkušnje brskanja, analizo prometa na spletnem mestu in personalizacijo vsebine. S klikom na \"Sprejmi vse\" se strinjate z uporabo piškotkov.",
    acceptAll: "Sprejmi vse",
    declineOptional: "Zavrni neobvezne"
  },

  // Mednarodni partnerji
  partners: {
    title: "Naši mednarodni partnerji",
    subtitle: "Zaupanja vredni sodelavci, ki širijo naš doseg in podpirajo stranke na ključnih svetovnih trgih.",
    websiteLabel: "Spletna stran",
    becomePartner: "Vas zanima, da postanete uradni distribucijski partner?",
    contactCta: "Stopite v stik",
    valsol: {
      tagline: "Distribucijski partner za Čile",
      description: "Uradni partner podjetja Xiamen Tower Technology Co., Ltd. za Čile.\nSpecializiran za neposredno nabavo in uvoz iz Kitajske, s poudarkom na zanesljivih dobavnih verigah ter podpori lokalnim strankam in trgu."
    }
  }
};